import { render } from "./label-mobile.vue?vue&type=template&id=67c28f7a&ts=true"
import script from "./label-mobile.vue?vue&type=script&lang=ts"
export * from "./label-mobile.vue?vue&type=script&lang=ts"

import "./label-mobile.vue?vue&type=style&index=0&id=67c28f7a&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__